// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"be98c3ce","239":"dc48f1eb","455":"c1064e2a"}[chunkId] + ".chunk.js";
};